import { COLOR_MAP } from '@constants/colors';

export const findBaseColor = (color: string):string => {
  for (const basicColor in COLOR_MAP) {
    for (const derivedColor of COLOR_MAP[basicColor as keyof typeof COLOR_MAP]) {
      if (color.match(new RegExp(derivedColor, 'i'))) {
        return basicColor;
      }
    }
  }

  return 'Other';
};
